export const env = {
  API_URL: (import.meta.env.VITE_API_URL as string | undefined) ?? '/api',
  DEVTOOLS_PROTECTION_ENABLED:
    import.meta.env.VITE_ENABLE_DEVTOOLS_PROTECTION === 'true',
  DEBUG_MODE: import.meta.env.VITE_DEBUG_MODE === 'true',
  /**
   * Rate API host. Only the address lives here — the passkey deliberately does
   * not, because Vite inlines every VITE_* value into the built JS, which would
   * hand it to anyone who opens DevTools. Staff type it into the salary gate
   * instead; see services/rateApi.service.ts.
   */
  RATE_API_URL: (import.meta.env.VITE_RATE_API_URL as string | undefined)
    ?? 'https://pms-b.rrcbase.com',
} as const;

/**
 * PIN required to access the sensitive Logs tab on /hrms/attendance.
 * Set VITE_LOGS_PIN_CODE in .env. If not set, the Logs PIN gate is disabled.
 */
export const LOGS_PIN_CODE: string =
  (import.meta.env.VITE_LOGS_PIN_CODE as string | undefined) ?? '';
